import { Box } from "@mui/material";
import { FC } from "react";
import Carousel from "../Carousel";
import { useIsMobileView } from "../../hooks/useWindowSize";
import { useStyles } from "./styles";

import IconPlus500 from "../../assets/images/home/plus500.svg";
import IconSubtract from "../../assets/images/home/subtract.svg";
import IconMelanion from "../../assets/images/home/melanion.svg";
import IconLgc from "../../assets/images/home/lgc.svg";
import IconEqm from "../../assets/images/home/EQM.svg";
import IconIClima from "../../assets/images/home/iclima.svg";
import IconImpak from "../../assets/images/home/impak.svg";
import IconQuantumrock from "../../assets/images/home/quantumrock.svg";
import IconLmax from "../../assets/images/home/lmax.svg";
import IconGain from "../../assets/images/home/gain.svg";
import IconSix from "../../assets/images/home/six.svg";
import IconAbrdn from "../../assets/images/home/abrdn.svg";
import IconGlobalx from "../../assets/images/home/globalx.svg";
import IconDirexion from "../../assets/images/home/direxion.svg";
import IconXm from "../../assets/images/home/xm.svg";
import IconPepperstone from "../../assets/images/home/pepperstone.svg";
import IconAvatrade from "../../assets/images/home/avatrade.svg";

const ClientsList: FC<{}> = () => {
  const classes = useStyles();
  const inMobile = useIsMobileView();

  if (inMobile) {
    return (
      <Box className={classes.mobileContainer}>
        <Carousel
          options={{
            infinite: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 2,
                  initialSlide: 2,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
            ],
          }}
        >
          <Box className={classes.item}>
            <img className={classes.image} src={IconSix} alt="Six" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconGlobalx} alt="GlobalX" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconAbrdn} alt="abrdn" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconPlus500} alt="Plus500" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconSubtract} alt="IG" />
          </Box>
          <Box className={classes.item}>
            <img
              className={classes.image}
              src={IconMelanion}
              alt="Malanion Capital"
            />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconIClima} alt="iClima" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconDirexion} alt="Direxion" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconXm} alt="XM" />
          </Box>
          <Box className={classes.item}>
            <img
              className={classes.image}
              src={IconPepperstone}
              alt="PepperStone"
            />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconAvatrade} alt="AvaTrade" />
          </Box>

          <Box className={classes.item}>
            <img className={classes.image} src={IconEqm} alt="EQM" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconLgc} alt="LGC" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconImpak} alt="impak" />
          </Box>
          <Box className={classes.item}>
            <img
              className={classes.image}
              src={IconQuantumrock}
              alt="QuantrumRock"
            />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconLmax} alt="LMAX" />
          </Box>
          <Box className={classes.item}>
            <img className={classes.image} src={IconGain} alt="Gain Capital" />
          </Box>
        </Carousel>
      </Box>
    );
  }

  return (
    <Box className={classes.container}>
      <Carousel
        options={{
          slidesToShow: 1,
          infinite: true,
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        }}
      >
        <Box>
          <Box className={classes.row} px={2}>
            <Box className={classes.item}>
              <img className={classes.image} src={IconSix} alt="Six" />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconGlobalx} alt="GlobalX" />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconIClima} alt="iClima" />
            </Box>
            <Box className={classes.item}>
              <img
                className={classes.image}
                src={IconDirexion}
                alt="Direxion"
              />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconXm} alt="XM" />
            </Box>
          </Box>
          <Box className={`${classes.row} ${classes.secondRow}`}>
            <Box className={classes.item}>
              <img
                className={classes.image}
                src={IconPepperstone}
                alt="PepperStone"
              />
            </Box>
            <Box className={classes.item}>
              <img
                className={classes.image}
                src={IconAvatrade}
                alt="AvaTrade"
              />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconAbrdn} alt="abrdn" />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconPlus500} alt="Plus500" />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconSubtract} alt="IG" />
            </Box>
          </Box>
        </Box>

        <Box>
          <Box className={classes.row} px={2}>
            <Box className={classes.item}>
              <img
                className={classes.image}
                src={IconMelanion}
                alt="Malanion Capital"
              />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconEqm} alt="EQM" />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconLgc} alt="LGC" />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconImpak} alt="impak" />
            </Box>
          </Box>
          <Box className={`${classes.row} ${classes.secondRow}`}>
            <Box className={classes.item}>
              <img
                className={classes.image}
                src={IconQuantumrock}
                alt="QuantrumRock"
              />
            </Box>
            <Box className={classes.item}>
              <img className={classes.image} src={IconLmax} alt="LMAX" />
            </Box>
            <Box className={classes.item}>
              <img
                className={classes.image}
                src={IconGain}
                alt="Gain Capital"
              />
            </Box>
          </Box>
        </Box>
      </Carousel>
    </Box>
  );
};

export default ClientsList;
